import { Link } from 'react-router-dom';

export default function TermsOfService() {
  return (
    <div className="policy-container">
      <div className="policy-header">
        <h1>📋 用户服务协议</h1>
        <p className="policy-version">版本：v1.0 | 生效日期：2026年6月</p>
        <Link to="/" className="btn btn-outline btn-sm">← 返回首页</Link>
      </div>

      <div className="policy-content">
        <section>
          <h2>一、协议概述</h2>
          <p>
            本用户服务协议（以下简称「本协议」）是您与「智伴精读」（以下简称「本应用」）之间的法律协议。
            使用本应用即表示您同意接受本协议的全部条款。
          </p>
        </section>

        <section>
          <h2>二、服务内容</h2>
          <p>本应用提供以下服务：</p>
          <ul>
            <li>外刊文章阅读</li>
            <li>英语学习练习（词汇、翻译、摘要）</li>
            <li>AI智能批改</li>
            <li>学习进度追踪</li>
          </ul>
        </section>

        <section>
          <h2>三、用户义务</h2>
          <ul>
            <li>提供真实、准确的注册信息</li>
            <li>妥善保管账户和密码</li>
            <li>不得利用本应用从事违法活动</li>
            <li>尊重知识产权，不得复制或传播内容</li>
          </ul>
        </section>

        <section>
          <h2>四、知识产权</h2>
          <p>
            本应用所有内容（包括文章、音频、图像等）的知识产权归本应用所有。
            用户仅获得非排他性的使用权，不得用于商业目的。
          </p>
        </section>

        <section>
          <h2>五、免责声明</h2>
          <p>
            本应用仅供学习参考，不构成任何形式的教育保证。
            对于因使用本应用产生的任何损失，本应用不承担责任。
          </p>
        </section>

        <section>
          <h2>六、服务变更与终止</h2>
          <p>
            本应用保留随时变更或终止服务的权利，无需提前通知用户。
            用户可随时注销账户终止使用。
          </p>
        </section>

        <section>
          <h2>七、联系方式</h2>
          <p>
            如有任何问题，请发送邮件至：support@aenedu.site
          </p>
        </section>
      </div>

      <div className="policy-footer">
        <p>© 2026 智伴精读 - 专注英语学习</p>
      </div>
    </div>
  );
}